import React from "react";
import { Modal } from "react-bootstrap";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";

const FileViewerModal = ({ show, onHide, fileUrl ,fromInvoice}) => {
  const fileType = fileUrl
    .split(".")
    .pop()
    .toLowerCase();

  const getfileType = (fileUrl) => {
    if (fileType === "pdf") {
      return "application/pdf";
    } else if (fileType === "jpg" || fileType === "jpeg") {
      return "image/jpeg";
    } else if (fileType === "png") {
      return "image/png";
    } else if (fileType === "gif") {
      return "image/gif";
    } else if (fileType === "bmp") {
      return "image/bmp";
    } else if (fileType === "doc" || fileType === "docx") {
      return "application/msword";
    } else if (fileType === "xls" || fileType === "xlsx") {
      return "application/vnd.ms-excel";
    } else if (fileType === "ppt" || fileType === "pptx") {
      return "application/vnd.ms-powerpoint";
    } else if (fileType === "txt") {
      return "text/plain";
    } else {
      return "image/jpeg";
    }
  };

  const docs = [
    {
      uri: fileUrl,
      fileType: fromInvoice !== undefined ? "pdf":  getfileType(fileUrl),
    },
  ];

  console.log("fileType", fileType)

  return (
    <div>
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex justify-content-between align-items-center w-100">
            <h6>
             {fromInvoice === true ? "Invoice": fromInvoice === false ? "Custom Bill" : "File Viewer"}
              </h6>
            <i className="fas fa-times cursor-pointer" onClick={onHide}></i>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "auto" }} className="DocViewerCla">
          {(fileType !== "jpg" && fileType !== "jpeg" && fileType !== "png") ? (
            <DocViewer
              documents={docs}
              initialActiveDocument={docs[0]}
              pluginRenderers={DocViewerRenderers}
              className="w-100 h-100"
            />
          ) : (
            <img src={fileUrl}   className="w-100 h-100" />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-secondary mr-3" onClick={onHide}>
            Close
          </button>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              window.open(fileUrl, "_blank");
            }}
          >
            Download
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FileViewerModal;
